import { Link } from "react-router-dom";
import { COLUMNS } from "../../mocks/mockContent";

const ABOUT_LINKS = [
  { name: "关于我们", to: "/about" },
  { name: "投稿吃瓜", to: "/about#contact" },
  { name: "内容声明", to: "/about#principles" },
];

export default function Footer() {
  const columns = COLUMNS.filter((c) => c.key !== "all");
  return (
    <footer className="mt-16 border-t hairline bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6">
        <div className="grid gap-10 md:grid-cols-4">
          {/* brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-flower-fill" aria-hidden="true"></i>
              </span>
              <span className="font-display text-xl font-bold text-foreground-950">瓜田日报</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-6 text-foreground-600">
              一站式健康吃瓜资讯门户，每日聚合明星动态、影视综艺、网络热梗与热搜解读。坚持「先核实再讨论」，陪你理性围观，不错过每一场精彩的公共话题。
            </p>
            <div className="mt-4 flex items-center gap-3 text-foreground-600">
              <span className="inline-flex items-center gap-1.5 text-sm">
                <i className="ri-mail-line" aria-hidden="true"></i>
                guatian@example.com
              </span>
              <span className="hidden text-sm sm:inline">|</span>
              <span className="hidden items-center gap-1.5 text-sm sm:inline-flex">
                <i className="ri-time-line" aria-hidden="true"></i>
                每日 08:00 更新
              </span>
            </div>
          </div>

          {/* columns */}
          <nav aria-label="内容栏目">
            <h3 className="font-display text-sm font-bold tracking-wide text-foreground-900">内容栏目</h3>
            <ul className="mt-4 space-y-2.5">
              {columns.map((c) => (
                <li key={c.key}>
                  <Link
                    to={`/rexun?cat=${encodeURIComponent(c.key)}`}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* about */}
          <nav aria-label="站点导航">
            <h3 className="font-display text-sm font-bold tracking-wide text-foreground-900">站点</h3>
            <ul className="mt-4 space-y-2.5">
              {ABOUT_LINKS.map((l) => (
                <li key={l.name}>
                  <Link to={l.to} className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                    {l.name}
                  </Link>
                </li>
              ))}
            </ul>
            <h3 className="font-display text-sm font-bold tracking-wide text-foreground-900 md:mt-6">栏目直达</h3>
            <Link to="/rexun" className="mt-3 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700">
              <i className="ri-fire-line" aria-hidden="true"></i>
              热榜吃瓜
            </Link>
          </nav>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t hairline pt-6 text-sm text-foreground-600 sm:flex-row sm:items-center">
          <p>© 2026 瓜田日报 · 健康吃瓜，理性围观。内容仅供娱乐交流使用。</p>
          <div className="flex items-center gap-3 text-foreground-500">
            <a href="https://www.example.com" target="_blank" rel="noopener nofollow" className="hover:text-primary-700">
              <i className="ri-qq-line text-lg" aria-hidden="true"></i>
            </a>
            <a href="https://www.example.com" target="_blank" rel="noopener nofollow" className="hover:text-primary-700">
              <i className="ri-weibo-line text-lg" aria-hidden="true"></i>
            </a>
            <a href="https://www.example.com" target="_blank" rel="noopener nofollow" className="hover:text-primary-700">
              <i className="ri-wechat-line text-lg" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}